module.exports = __webpack_public_path__ + "img/s1Black.88f220f2.png";